import { useState, useEffect } from "react";
import { useAuth } from "../../auth/AuthContext";
import { formatarNomeUpper } from "../../utils/formatadores";
import { api } from "../../api/api.js";
import DOMPurify from "dompurify";
import ModalDocumentoTemplate from "../../components/documentos/ModalDocumentoTemplate.jsx";

const GerenciamentoDocumentos = () => {
  const { user, loading } = useAuth();
  const [templates, setTemplates] = useState([]);
  const [clientes, setClientes] = useState([]);
  
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedCabRod, setSelectedCabRod] = useState("");
  const [isCabRodDisabled, setIsCabRodDisabled] = useState(false);
  
  const [conteudoGerado, setConteudoGerado] = useState("");
  const [actionType, setActionType] = useState(null);

  const [documentoMeta, setDocumentoMeta] = useState({ titulo: "Documento", nomeCliente: "Cliente" });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const carregarTemplates = () => {
    api.get("/documentos/templates")
      .then((res) => setTemplates(res.data))
      .catch((err) => console.error("Erro ao carregar templates:", err));
  };

  useEffect(() => {
    api.get("/documentos/templates")
      .then((res) => setTemplates(res.data))
      .catch((err) => console.error("Erro ao carregar templates:", err));

    api.get("/clientes")
      .then((res) => setClientes(res.data))
      .catch((err) => console.error("Erro ao carregar clientes:", err));
  }, []);

  if (loading) return <p>Carregando...</p>;
  if (!user) return <p>Não autorizado</p>;

  // =======================================================
  // AUTOMATIZAÇÃO DO SELETOR DE CABEÇALHO E RODAPÉ
  // =======================================================
  const handleTemplateChange = (templateId) => {
    setSelectedTemplate(templateId);

    if (!templateId) {
      setIsCabRodDisabled(false);
      return;
    }

    const templateObj = templates.find((t) => t._id === templateId);
    if (!templateObj || !templateObj.titulo) {
      setIsCabRodDisabled(false);
      return;
    }

    const titulo = templateObj.titulo.toLowerCase();

    if (titulo.includes("fernando e rayane")) {
      setSelectedCabRod("Fernando e Rayane");
      setIsCabRodDisabled(true);
    } else if (titulo.includes("rayane e fernando")) {
      setSelectedCabRod("Rayane e Fernando");
      setIsCabRodDisabled(true);
    } else if (titulo.includes("fernando") && !titulo.includes("rayane")) {
      setSelectedCabRod("Fernando");
      setIsCabRodDisabled(true);
    } else if (titulo.includes("rayane") && !titulo.includes("fernando")) {
      setSelectedCabRod("Rayane");
      setIsCabRodDisabled(true);
    } else {
      setIsCabRodDisabled(false);
    }
  };

  const handleGerarDocumento = async (e) => {
    e.preventDefault();
    if (!selectedTemplate || !selectedCliente) {
      alert("Selecione um modelo e um cliente.");
      return;
    }

    setActionType("gerar");
    try {
      const response = await api.post("/documentos/gerar", { 
        templateId: selectedTemplate, 
        clienteId: selectedCliente 
      });
      
      const data = response.data;
      
      const htmlLimpo = DOMPurify.sanitize(data.conteudo);
      setConteudoGerado(htmlLimpo);
      
      const clienteObj = clientes.find(c => c._id === selectedCliente);
      setDocumentoMeta({
        titulo: data.titulo || "Documento",
        nomeCliente: clienteObj ? formatarNomeUpper(clienteObj.nomeCliente) : "Cliente"
      });

    } catch (error) {
      const mensagemErro = error.response?.data?.erro || "Erro ao gerar documento.";
      alert("Erro: " + mensagemErro);
    } finally {
      setActionType(null);
    }
  };

  const extrairCorpoEEstilosHTML = (html) => {
    const parser = new DOMParser();
    const documento = parser.parseFromString(html, "text/html");

    const tagEstilo = documento.querySelector("style");
    const estilosGoogle = tagEstilo ? tagEstilo.innerHTML : "";

    return {
      conteudoCorpo: documento.body.innerHTML,
      estilosGoogle: estilosGoogle
    };
  };

  // =======================================================
  // 1. FUNÇÃO PARA IMPRIMIR E GERAR PDF
  // =======================================================
  const handleImprimir = () => {
    const baseUrl = window.location.origin;
    const { conteudoCorpo, estilosGoogle } = extrairCorpoEEstilosHTML(conteudoGerado);

    const nomeArquivo = `${documentoMeta.titulo} ${documentoMeta.nomeCliente}`;
    const tituloOriginalPagina = document.title;

    // Lógica dinâmica para o Cabeçalho
    let htmlCabecalho = "";
    if (selectedCabRod === "Rayane e Fernando") {
      htmlCabecalho = `
        <div style="margin-bottom: 15px; text-align: center;">
          <img src="${baseUrl}/cabecalho_rayane_fernando.png" style="width: 100%; max-width: 600px; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Fernando e Rayane") {
      htmlCabecalho = `
        <div style="margin-bottom: 15px; text-align: center;">
          <img src="${baseUrl}/cabecalho_fernando_rayane.png" style="width: 100%; max-width: 600px; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Rayane") {
      htmlCabecalho = `
        <div style="margin-bottom: 15px; text-align: center;">
          <img src="${baseUrl}/cabecalho_rayane.png" style="width: 100%; max-width: 600px; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Fernando") {
      htmlCabecalho = `
        <div style="margin-bottom: 15px; text-align: center;">
          <img src="${baseUrl}/cabecalho_fernando.png" style="width: 100%; max-width: 600px; display: block; margin: 0 auto;" />
        </div>
      `;
    }

    // Lógica dinâmica para o Rodapé
    let htmlRodape = "";
    if (selectedCabRod === "Rayane e Fernando") {
      htmlRodape = `
        <div style="margin-top: 30px; text-align: center;">
          <img src="${baseUrl}/rodape_rayane.png" style="width: 559px; height: 36px; display: block; margin: 0 auto;" />
          <img src="${baseUrl}/rodape_fernando.png" style="width: 557px; height: 38px; display: block; margin: 0 auto 3px auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Fernando e Rayane") {
      htmlRodape = `
        <div style="margin-top: 30px; text-align: center;">
          <img src="${baseUrl}/rodape_fernando.png" style="width: 557px; height: 38px; display: block; margin: 0 auto 3px auto;" />
          <img src="${baseUrl}/rodape_rayane.png" style="width: 559px; height: 36px; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Rayane") {
      htmlRodape = `
        <div style="margin-top: 30px; text-align: center;">
          <img src="${baseUrl}/rodape_rayane.png" style="width: 559px; height: 36px; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Fernando") {
      htmlRodape = `
        <div style="margin-top: 30px; text-align: center;">
          <img src="${baseUrl}/rodape_fernando.png" style="width: 557px; height: 38px; display: block; margin: 0 auto;" />
        </div>
      `;
    }

    const htmlCompleto = `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        <title>${nomeArquivo}</title>
        <style>
          ${estilosGoogle}
          
          @page {
            size: A4;
            margin: 0.8cm 2cm 0.8cm 3cm;
          }

          body {
            font-family: Arial, sans-serif;
            color: #000;
            background: #fff;
          }
        </style>
      </head>
      <body>
        <table style="width: 100%; border: none;">
          ${htmlCabecalho ? `
          <thead>
            <tr>
              <td style="border: none;">
                ${htmlCabecalho}
              </td>
            </tr>
          </thead>
          ` : ""}
          
          <tbody>
            <tr>
              <td style="border: none;">
                ${conteudoCorpo}
              </td>
            </tr>
          </tbody>

          ${htmlRodape ? `
          <tfoot>
            <tr>
              <td style="border: none;">
                ${htmlRodape}
              </td>
            </tr>
          </tfoot>
          ` : ""}
        </table>
      </body>
      </html>
    `;

    document.title = nomeArquivo;

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(htmlCompleto);
    doc.close();

    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      
      document.title = tituloOriginalPagina;

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }, 800);
  };

  // =======================================================
  // 2. FUNÇÃO PARA BAIXAR EM WORD (.DOC) - MARGENS CORRIGIDAS
  // =======================================================
  const handleBaixarWord = () => {
    const baseUrl = window.location.origin;
    const { conteudoCorpo, estilosGoogle } = extrairCorpoEEstilosHTML(conteudoGerado);

    const nomeTitulo = `${documentoMeta.titulo} ${documentoMeta.nomeCliente}`;
    const nomeArquivo = `${nomeTitulo}.doc`;

    let corpoTratado = conteudoCorpo;
    corpoTratado = corpoTratado.replace(/<span([^>]*?)font-weight:\s*700([^>]*?)>(.*?)<\/span>/gi, "<span$1$2><b>$3</b></span>");
    corpoTratado = corpoTratado.replace(/<span([^>]*?)font-style:\s*italic([^>]*?)>(.*?)<\/span>/gi, "<span$1$2><i>$3</i></span>");
    corpoTratado = corpoTratado.replace(/<span([^>]*?)text-decoration:\s*underline([^>]*?)>(.*?)<\/span>/gi, "<span$1$2><u>$3</u></span>");

    // Lógica dinâmica para o Cabeçalho
    let htmlCabecalho = "";
    if (selectedCabRod === "Rayane e Fernando") {
      htmlCabecalho = `
        <div style="margin-bottom: 15px; text-align: center;">
          <img src="${baseUrl}/cabecalho_rayane_fernando.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Fernando e Rayane") {
      htmlCabecalho = `
        <div style="margin-bottom: 15px; text-align: center;">
          <img src="${baseUrl}/cabecalho_fernando_rayane.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Rayane") {
      htmlCabecalho = `
        <div style="margin-bottom: 15px; text-align: center;">
          <img src="${baseUrl}/cabecalho_rayane.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Fernando") {
      htmlCabecalho = `
        <div style="margin-bottom: 15px; text-align: center;">
          <img src="${baseUrl}/cabecalho_fernando.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />
        </div>
      `;
    }

    // Lógica dinâmica para o Rodapé
    let htmlRodape = "";
    if (selectedCabRod === "Rayane e Fernando") {
      htmlRodape = `
        <div style="margin-top: 30px; text-align: center;">
          <img src="${baseUrl}/rodape_rayane.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto 3px auto;" />
          <img src="${baseUrl}/rodape_fernando.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Fernando e Rayane") {
      htmlRodape = `
        <div style="margin-top: 30px; text-align: center;">
          <img src="${baseUrl}/rodape_fernando.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto 3px auto;" />
          <img src="${baseUrl}/rodape_rayane.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Rayane") {
      htmlRodape = `
        <div style="margin-top: 30px; text-align: center;">
          <img src="${baseUrl}/rodape_rayane.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />
        </div>
      `;
    } else if (selectedCabRod === "Fernando") {
      htmlRodape = `
        <div style="margin-top: 30px; text-align: center;">
          <img src="${baseUrl}/rodape_fernando.png" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />
        </div>
      `;
    }

    const htmlCompleto = `
      <html xmlns:o='urn:schemas-microsoft-com:office:office' 
            xmlns:w='urn:schemas-microsoft-com:office:word' 
            xmlns='http://www.w3.org/TR/REC-html40'>
      <head>
        <meta charset='utf-8'>
        <title>${nomeTitulo}</title>
        <style>
          ${estilosGoogle}
          
          @page Section1 {
            size: 595.3pt 841.9pt; /* Folha A4 */
            margin: 2.5cm 2.0cm 2.5cm 3.0cm; /* Superior, Direita, Inferior, Esquerda */
            mso-header-margin: 1.0cm;
            mso-footer-margin: 1.0cm;
          }

          div.Section1 {
            page: Section1;
          }

          body {
            font-family: Arial, sans-serif;
            color: #000;
            background: #fff;
            word-wrap: break-word;
          }

          p, div, span, table {
            max-width: 100% !important;
            box-sizing: border-box;
          }

          table {
            border-collapse: collapse;
            width: 100%;
            margin-bottom: 10pt;
          }

          img {
            max-width: 100% !important;
            height: auto !important;
          }
        </style>
      </head>
      <body>
        <div class="Section1">
          ${htmlCabecalho}
          
          <div className="content">
            ${corpoTratado}
          </div>

          ${htmlRodape}
        </div>
      </body>
    </html>
    `;

    const blob = new Blob(['\ufeff' + htmlCompleto], {
      type: 'application/msword'
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="container">
      <div className="card">
        <h1>GESTÃO E ELABORAÇÃO DE DOCUMENTOS</h1>

        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          {["admin", "advogado"].includes(user?.role) && (
            <button 
              className="btn-salvar"
              style={{ backgroundColor: "#28a745", cursor: "pointer" }}
              onClick={() => setIsModalOpen(true)}
            >
              Criar Documento
            </button>
          )}
        </div>
        <form onSubmit={handleGerarDocumento}>
          <div className="form-grid">
            
            <div className="form-group">
              <label>Selecione o Modelo (Drive) <span style={{ color: "red" }}>*</span></label>
              <select
                value={selectedTemplate}
                onChange={(e) => handleTemplateChange(e.target.value)}
                required
                style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
              >
                <option value="">-- Escolha o Modelo --</option>
                {templates.map((t) => (
                  <option key={t._id} value={t._id}>{t.titulo}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Selecione o Cliente (Qualificação) <span style={{ color: "red" }}>*</span></label>
              <select
                value={selectedCliente}
                onChange={(e) => setSelectedCliente(e.target.value)}
                required
                style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
              >
                <option value="">-- Escolha o Cliente --</option>
                {clientes.map((c) => (
                  <option key={c._id} value={c._id}>{formatarNomeUpper(c.nomeCliente)} CPF: {c.cpf}</option>
                ))}
              </select>
            </div>

            <div className="form-group" style={{ gridColumn: "1 / -1" }}>
              <label>Cabeçalho e Rodapé Dinâmico <span style={{ color: "red" }}>*</span></label>
              <select
                value={selectedCabRod}
                onChange={(e) => setSelectedCabRod(e.target.value)}
                disabled={isCabRodDisabled}
                required
                style={{ 
                  width: "100%", 
                  padding: "8px", 
                  borderRadius: "4px", 
                  border: "1px solid #ccc",
                  backgroundColor: isCabRodDisabled ? "#e9ecef" : "#fff",
                  cursor: isCabRodDisabled ? "not-allowed" : "default"
                }}
              >
                <option value="">-- Escolha o timbre --</option>
                <option value="Fernando e Rayane">Fernando e Rayane</option>
                <option value="Rayane e Fernando">Rayane e Fernando</option>
                <option value="Fernando">Fernando</option>
                <option value="Rayane">Rayane</option>
                <option value="Sem cabeçalho e rodapé">Sem cabeçalho e rodapé</option>
              </select>
            </div>

          </div>

          <button 
            className="btn-salvar" 
            type="submit"
            disabled={actionType !== null}
            style={{ marginTop: "1rem" }}
          >
            {actionType === "gerar" ? <span className="spinner-loader"></span> : "Gerar Documento"}
          </button>
        </form>

        {conteudoGerado && (
          <div style={{ marginTop: "2rem" }}>
            <h3>Pré-visualização do Documento</h3>
            <div 
              style={{ background: "#f9f9f9", padding: "1.5rem", border: "1px solid #ddd", borderRadius: "4px", minHeight: "200px" }}
              dangerouslySetInnerHTML={{ __html: conteudoGerado }}
            />
            
            <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
              <button 
                className="btn-salvar" 
                onClick={handleBaixarWord}
                style={{ backgroundColor: "#007bff" }}
              >
                Baixar em Word (.doc)
              </button>

              <button 
                className="btn-salvar" 
                onClick={handleImprimir}
                style={{ backgroundColor: "#28a745" }}
              >
                Imprimir / Salvar PDF
              </button>
            </div>
          </div>
        )}

      </div>
      <ModalDocumentoTemplate
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onTemplateCriado={carregarTemplates}
      />
    </div>
  );
};

export default GerenciamentoDocumentos;